import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { ChevronLeftIcon, ShoppingBagIcon } from 'lucide-react';
export function Checkout() {
  const {
    cart,
    subtotal,
    totalItems
  } = useCart();
  const shipping = subtotal > 300 ? 0 : 25;
  const tax = subtotal * 0.06;
  const total = subtotal + shipping + tax;
  if (cart.length === 0) {
    return <div className="bg-white min-h-screen pt-40 pb-20 px-6 text-center" data-id="element-464">
        <div className="max-w-md mx-auto" data-id="element-465">
          <ShoppingBagIcon className="w-16 h-16 text-black/10 mx-auto mb-8 stroke-[1px]" data-id="element-466" />
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-widest uppercase mb-4" data-id="element-467">
            Your bag is empty
          </h1>
          <p className="text-sm md:text-base font-light text-black/60 uppercase tracking-widest mb-12" data-id="element-468">
            Add some heritage pieces to your bag to proceed with checkout.
          </p>
          <Link to="/new-in" className="inline-block bg-black text-white px-12 py-5 text-xs font-display font-bold uppercase tracking-[0.3em] hover:bg-black/80 transition-colors" data-id="element-469">
            Start Shopping
          </Link>
        </div>
      </div>;
  }
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-470">
      <div className="max-w-[1200px] mx-auto" data-id="element-471">
        <header className="mb-16" data-id="element-472">
          <Link to="/" className="inline-flex items-center space-x-2 text-xs font-display font-bold tracking-widest uppercase text-black/40 hover:text-black transition-colors mb-8" data-id="element-473">
            <ChevronLeftIcon className="w-3 h-3" data-id="element-474" />
            <span data-id="element-475">Continue Shopping</span>
          </Link>
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase" data-id="element-476">
            Order Summary
          </h1>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-477">
          {/* Items List */}
          <div className="lg:col-span-7 space-y-8" data-id="element-478">
            <div className="border-b border-grey-divider pb-4" data-id="element-479">
              <h2 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase text-black/40" data-id="element-480">
                Your Items ({totalItems})
              </h2>
            </div>
            <div className="space-y-8" data-id="element-481">
              {cart.map(item => <div key={`${item.id}-${item.size}-${item.color}`} className="flex space-x-6" data-id="element-482">
                  <div className="w-32 aspect-[3/4] bg-grey-divider overflow-hidden flex-shrink-0" data-id="element-483">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-484" />
                  </div>
                  <div className="flex-grow py-2 flex flex-col justify-between" data-id="element-485">
                    <div data-id="element-486">
                      <h3 className="text-sm font-display font-bold uppercase tracking-widest mb-2" data-id="element-487">
                        {item.name}
                      </h3>
                      <div className="space-y-1 text-xs font-display tracking-widest uppercase text-black/50" data-id="element-488">
                        {item.size && <p data-id="element-489">Size: {item.size}</p>}
                        {item.color && <p data-id="element-490">Color: {item.color}</p>}
                        <p data-id="element-491">Quantity: {item.quantity}</p>
                      </div>
                    </div>
                    <p className="text-sm font-display font-bold" data-id="element-492">
                      {item.price}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Totals Card */}
          <div className="lg:col-span-5" data-id="element-493">
            <div className="bg-grey-divider/10 p-8 md:p-12 sticky top-32" data-id="element-494">
              <h2 className="text-sm md:text-base font-display font-bold tracking-widest uppercase mb-10 border-b border-grey-divider pb-4" data-id="element-495">
                Order Totals
              </h2>

              <div className="space-y-6 mb-10" data-id="element-496">
                <div className="flex justify-between text-xs font-display tracking-widest uppercase" data-id="element-497">
                  <span className="text-black/40" data-id="element-498">Subtotal</span>
                  <span className="font-bold" data-id="element-499">${subtotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-xs font-display tracking-widest uppercase" data-id="element-500">
                  <span className="text-black/40" data-id="element-501">Estimated Shipping</span>
                  <span className="font-bold" data-id="element-502">
                    {shipping === 0 ? 'FREE' : `$${shipping.toFixed(2)}`}
                  </span>
                </div>
                <div className="flex justify-between text-xs font-display tracking-widest uppercase" data-id="element-503">
                  <span className="text-black/40" data-id="element-504">Estimated Tax</span>
                  <span className="font-bold" data-id="element-505">${tax.toFixed(2)}</span>
                </div>
                <div className="pt-6 border-t border-grey-divider flex justify-between items-baseline" data-id="element-506">
                  <span className="text-sm font-display font-bold tracking-widest uppercase" data-id="element-507">
                    Total
                  </span>
                  <span className="text-2xl font-display font-bold" data-id="element-508">
                    ${total.toFixed(2)}
                  </span>
                </div>
              </div>

              <button className="w-full bg-black text-white py-6 text-xs font-display font-bold uppercase tracking-[0.4em] hover:bg-black/80 transition-colors mb-6" data-id="element-509">
                Proceed to Payment
              </button>

              <div className="space-y-4 pt-4 border-t border-grey-divider" data-id="element-510">
                <p className="text-xs font-display tracking-widest uppercase text-black/40 leading-relaxed" data-id="element-511">
                  By clicking "Proceed to Payment", you agree to our Terms of
                  Service and Privacy Policy.
                </p>
                <div className="flex items-center space-x-4 grayscale opacity-40" data-id="element-512">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" className="h-3" data-id="element-513" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-5" data-id="element-514" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-4" data-id="element-515" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}